<template>
  <div data-cy="email-fields">
    <div class="font-bold">Primary Email</div>
    <EmailField
      ref="primaryEmailField"
      :key="`primary-${emailsValidationKey}`"
      v-model="primaryEmail"
      primary
      :unique-account-email-validator="uniqueAccountEmailValidator"
    />
    <div v-if="additionalEmails.length" class="font-bold">
      Additional Email(s)
    </div>
    <div ref="fieldsContainer" class="scrollable-fields-container mb-3">
      <div
        v-for="(email, i) in additionalEmails"
        :key="`${email.id}-${emailsValidationKey}`"
      >
        <!-- eslint-disable vue/no-mutating-props -->
        <EmailField
          ref="emailFields"
          v-model="additionalEmails[i]"
          :primary="email.primary"
          :unique-account-email-validator="uniqueAccountEmailValidator"
          @delete-email="handleDelete($event, i + 1)"
        />
        <!--eslint-enable-->
      </div>
    </div>
    <div class="icon-margin-right-2x">
      <ItemAdder
        text="Add Email"
        class="adder full-width"
        slim
        transparent
        data-cy="add-email"
        @click="addEmail"
      />
    </div>
  </div>
</template>

<script>
import { nextTick } from "vue";
import { generateUID } from "@/lib/helpers.js";

import ItemAdder from "@/components/ItemAdder.vue";
import EmailField from "@/Customer/EmailField.vue";
import { createUniqueAccountEmailValidator } from "@/mixins/validationRules.js";
import useVuelidate from "@vuelidate/core";

export default {
  components: {
    EmailField,
    ItemAdder
  },
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  computed: {
    primaryEmail: {
      get() {
        return this.formData.emails.find((email) => email.primary);
      },
      set(value) {
        // eslint-disable-next-line vue/no-mutating-props
        this.formData.emails = this.formData.emails.map((email) => {
          if (email.id === value.id) {
            return { ...value };
          }

          return email;
        });
      }
    },
    additionalEmails() {
      return this.formData.emails.filter((email) => !email.primary);
    },
    uniqueAccountEmailValidator() {
      return createUniqueAccountEmailValidator(this.formData.emails);
    },
    emailsValidationKey() {
      return this.formData.emails.map((e) => e.id).join("-");
    }
  },
  created() {
    if (!this.primaryEmail) {
      this.addEmail(true);
    }
  },
  methods: {
    addEmail(primary = false) {
      const newEmail = {
        id: generateUID(),
        new: true,
        email_address: "",
        label: "",
        primary: primary
      };

      if (newEmail.primary) {
        // eslint-disable-next-line vue/no-mutating-props
        this.formData.emails = [newEmail, ...this.formData.emails];
      } else {
        // eslint-disable-next-line vue/no-mutating-props
        this.formData.emails = [...this.formData.emails, newEmail];
      }

      nextTick(() => {
        this.$refs.fieldsContainer.scrollTop =
          this.$refs.fieldsContainer.scrollHeight;
      });
    },
    handleDelete(email, index) {
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.emails = this.formData.emails.filter(
        (altEmail, i) => i !== index
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.adder {
  height: 35px !important;
  min-height: 35px !important;
}
</style>
